<template>
  <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
    <router-link
      :to="_.get(itemData, 'smartbuttons.0.url')"
      class="head-banner link-banner fadeUp"
      v-if="itemData"
      :class="animate ? 'animate' : ''"
    >
      <div class="mt-89">
        <div class="img-box parallaxe">
          <picture>
            <source
              media="(max-width: 767px)"
              :srcset="
                _.get(itemData, [
                  'cover_image',
                  Object.keys(itemData.cover_image),
                  'url',
                ])
              "
            />
            <source
              media="(max-width: 1023px)"
              :srcset="
                _.get(itemData, [
                  'cover_image',
                  Object.keys(itemData.cover_image),
                  'url',
                ])
              "
            />
            <img
              :src="
                _.get(itemData, [
                  'cover_image',
                  Object.keys(itemData.cover_image),
                  'url',
                ])
              "
              class="img-absolute"
              alt
              v-prlx="{ speed: 0.08 }"
            />
          </picture>
          <div class="img-overlay"></div>
        </div>
        <div class="container banner-content flex-box column">
          <h2 class="main-title white">{{ _.get(itemData, "title") }}</h2>
          <p class="white">{{ _.get(itemData, "teaser") }}</p>
          <div class="btn sub bg-white">
            {{ _.get(itemData, "smartbuttons.0.title") }}
          </div>
        </div>
      </div>
    </router-link>
  </intersect>
</template>

<script>
import Vue from "vue";
import Intersect from "vue-intersect";
import Paralax from "@/assets/js/paralax.js";
Vue.directive("prlx", Paralax);

export default {
  props: {
    itemData: Object,
    required: true,
  },
  components: {
    Intersect,
  },
  data() {
    return {
      animate: false,
    };
  },
};
</script>
